'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeDecoratorRefCallback = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getCoreComponent = getCoreComponent;
exports.attachWrappedComponent = attachWrappedComponent;
exports.copyMethods = copyMethods;
exports.eventHandlerDecoratorFactory = eventHandlerDecoratorFactory;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getCoreComponent(Component) {
  var node = Component;
  while (node.WrappedComponent) {
    node = node.WrappedComponent;
  }

  return node;
}

function attachWrappedComponent(Decorator, WrappedComponent) {
  Decorator.WrappedComponent = WrappedComponent;
  Decorator.CoreComponent = getCoreComponent(WrappedComponent);
}

function copyMethods(wrappedInstance, decoratorInstance) {
  // Copy all methods from the wrapped component instance to this wrapper,
  // so that this wrapper is usable as a ref.
  if (!wrappedInstance) {
    return;
  }
  Object.getOwnPropertyNames(wrappedInstance).filter(function (key) {
    return key !== 'getDOMNode';
  }) // See #4515
  .forEach(function (key) {
    if (typeof wrappedInstance[key] === 'function' && !decoratorInstance[key]) {
      decoratorInstance[key] = wrappedInstance[key];
    }
  });
}

var makeDecoratorRefCallback = exports.makeDecoratorRefCallback = function makeDecoratorRefCallback(Component, decoratorInstance) {
  if (!Component.prototype.render) return undefined; // functional component
  return function (ref) {
    copyMethods(ref, decoratorInstance);
  };
};

function eventHandlerDecoratorFactory(_ref) {
  var componentWillUnmount = _ref.componentWillUnmount,
      shouldComponentUpdate = _ref.shouldComponentUpdate,
      displayNameFunc = _ref.displayNameFunc,
      _ref$initialState = _ref.initialState,
      initialState = _ref$initialState === undefined ? {} : _ref$initialState,
      propTypes = _ref.propTypes,
      defaultProps = _ref.defaultProps,
      eventHandlers = _ref.eventHandlers,
      getPropsForRender = _ref.getPropsForRender;

  return function (Component) {
    var EventHandlerDecorator = function (_React$Component) {
      _inherits(EventHandlerDecorator, _React$Component);

      function EventHandlerDecorator(props) {
        _classCallCheck(this, EventHandlerDecorator);

        var _this = _possibleConstructorReturn(this, (EventHandlerDecorator.__proto__ || Object.getPrototypeOf(EventHandlerDecorator)).call(this, props));

        _this.state = _extends({}, initialState);
        _this._boundEventHandlers = {};
        if (componentWillUnmount) {
          _this.componentWillUnmount = componentWillUnmount.bind(_this);
        }
        if (shouldComponentUpdate) {
          _this.shouldComponentUpdate = shouldComponentUpdate.bind(_this);
        }
        Object.keys(eventHandlers).forEach(function (eventHandlerName) {
          _this._boundEventHandlers[eventHandlerName] = function (evt) {
            eventHandlers[eventHandlerName].call(_this, evt);
            (0, _Functions.callIfPossible)(_this.props[eventHandlerName], evt);
          };
        });
        _this._refCallback = makeDecoratorRefCallback(Component, _this);
        return _this;
      }

      _createClass(EventHandlerDecorator, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Component, _extends({}, getPropsForRender(this.props, this.state), this._boundEventHandlers, {
            ref: this._refCallback
          }));
        }
      }]);

      return EventHandlerDecorator;
    }(_react2.default.Component);

    EventHandlerDecorator.displayName = displayNameFunc(Component);
    attachWrappedComponent(EventHandlerDecorator, Component);

    var eventHandlerPropTypes = {};
    Object.keys(eventHandlers).forEach(function (eventHandlerName) {
      eventHandlerPropTypes[eventHandlerName] = _react.PropTypes.func;
    });
    EventHandlerDecorator.propTypes = _extends({}, Component.propTypes, eventHandlerPropTypes, propTypes);
    EventHandlerDecorator.defaultProps = _extends({}, Component.defaultProps, defaultProps);

    return EventHandlerDecorator;
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/decorators/utils.js
// module id = 32
// module chunks = 0